import cn from 'classnames';
import { TitleProps } from './types';

const Title = ({ reebelocareProtection, className = '' }: TitleProps) => (
  <h4 className={cn('text-xs font-bold', className)}>
    ReebeloCare: {reebelocareProtection}
  </h4>
);

export default Title;
